'use client'

import { useEffect } from 'react'

import type { ModelsUserFullInfoResponse } from '@/api/generated-api'
import { useUserMe } from '@/hooks/useUserMe'

type HeaderAuthProbeProps = {
  onState: (state: {
    user: ModelsUserFullInfoResponse | undefined
    hasToken: boolean
  }) => void
}

export default function HeaderAuthProbe({ onState }: HeaderAuthProbeProps) {
  const { data: user, hasToken } = useUserMe()

  useEffect(() => {
    onState({ user, hasToken })
  }, [user, hasToken, onState])

  return null
}
